import { render, staticRenderFns } from "./HospitalizationHistorySelector.vue?vue&type=template&id=76162a16&scoped=true&"
import script from "./HospitalizationHistorySelector.vue?vue&type=script&lang=ts&"
export * from "./HospitalizationHistorySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76162a16",
  null
  
)

export default component.exports